import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


import { IPaymentApiClient } from './i-payment.api.client';
import { CollectionApiClient, IPaginationParameters, IPaginationResponse } from '../../../common';
import { PaymentManagementCollections } from '../../common';

import { IPaymentRequestResponse } from '../../payment-request';
import { IPaymentLookupsResponse, IPaymentResponse } from '../dtos/responses';

@Injectable({
  providedIn: 'root'
})
export class PaymentApiClient implements IPaymentApiClient {
  private collectionApiClient: CollectionApiClient;

  constructor(protected http: HttpClient) {
    this.collectionApiClient = CollectionApiClient.create(PaymentManagementCollections.Payments, http);
  }
  get(paginationParameters?: IPaginationParameters): Observable<IPaginationResponse<IPaymentResponse>> {
    return this.collectionApiClient.get({
      paginationParameters
    });
  }

  getById(id: string): Observable<IPaymentResponse> {
    return this.collectionApiClient.get({
      id
    });
  }

  getPaymentRequest(id: string): Observable<IPaymentRequestResponse> {
    return this.collectionApiClient.get({
      collectionName: PaymentManagementCollections.paymentPaymentRequest(id)
    });
  }

  lookups(paginationParameters?: IPaginationParameters): Observable<IPaymentLookupsResponse> {
    const params = {
      collectionName: PaymentManagementCollections.paymentLookups(),
      ...(paginationParameters && { paginationParameters })
    };
    return this.collectionApiClient.get(params);
  }
}
